import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';

const client = createAxiosClient({ baseURL: '' }, ServiceProxyMap.AUTH);

interface GetAccountDetailsByAaidsRestrictedRequest {
  atlassianAccountIds: Array<string>;
}

interface GetAccountDetailsByEmailsRequest {
  emails: string[];
}

interface AccountDetailsRestricted {
  name: string;
  account_id: string;
  picture: string;
  account_status: string;
  email?: string;
}

interface AccountDetails {
  accountId: string;
  email: string;
  name: string;
  picture: string;
}

interface AccountDetailsByEmails {
  account_id: string;
  email: string;
}

type GetAccountDetailsByAaidsRestrictedResponse = Array<AccountDetailsRestricted>;
type GetAccountDetailsByAaidsResponse = Array<AccountDetails>;
type GetAccountIdsByEmailsResponse = Array<AccountDetailsByEmails>;

export const getAccountDetailsByAaidsRestricted = async (
  requestPayload: GetAccountDetailsByAaidsRestrictedRequest
): Promise<GetAccountDetailsByAaidsRestrictedResponse> => {
  const response = await client.post('/api/1/users/fetch/by-accountIds/restricted', requestPayload);
  return response.data;
};

export const getAccountDetailsByAaids = async (
  requestPayload: GetAccountDetailsByAaidsRestrictedRequest
): Promise<GetAccountDetailsByAaidsResponse> => {
  const response = await client.post('/api/1/users/fetch/by-accountIds', requestPayload);
  return (response.data ?? []).map(
    ({
      id,
      primaryEmail,
      displayName,
      picture,
    }: {
      id: string;
      primaryEmail: string;
      displayName: string;
      picture: string;
    }) => ({
      accountId: id,
      name: displayName,
      email: primaryEmail,
      picture: picture,
    })
  );
};

export const getAccountDetailsByEmails = async (
  requestPayload: GetAccountDetailsByEmailsRequest
): Promise<GetAccountIdsByEmailsResponse> => {
  const response = await client.post('/api/1/users/fetch/by-email', requestPayload);
  return response.data;
};
